import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem('a97vin-token');
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

// Un jeton expiré ne doit pas laisser l'écran à moitié vivant : on repart au
// formulaire de connexion plutôt que d'empiler des erreurs.
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      localStorage.removeItem('a97vin-token');
      window.location.reload();
    }
    return Promise.reject(e);
  }
);

export default api;
